import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ProductStockMovementReference } from '../models/product-stock-movement-reference.model';

@Injectable({
  providedIn: 'root'
})
export class StockMovementReferenceService {

  /**
  * Endpoint for http calls
  */
  private _endpoint: string = environment.api.endpoint;

  constructor(private httpClient: HttpClient) { }

  /**
   * The reasons a movement can be posted against, for the picker on the operation screens.
   *
   * @returns Observable<ProductStockMovementReference[]>
   */
  getAllStockMovementReferences(): Observable<ProductStockMovementReference[]> {
    return this.httpClient.get(this._endpoint + 'product-stock-movement-reference?sort=name,ASC')
      .pipe(map((data) => {
        return <ProductStockMovementReference[]>data;
      }));
  }
}
